/// <reference types="@rspack/core/module" />

// Every page surface's non-English bundles, found by the bundler: a new scope or lang needs no edit
// here. English isn't loaded here; each call site's file imports its own scope's. require.context,
// not import.meta.webpackContext: Storybook's webpack build doesn't support the latter.
const bundles = require.context(
  './',
  true,
  /^\.\/[^/]+\/(?!en\.wjs\.jsx$)[\w-]+\.wjs\.jsx$/,
  'lazy',
);

const keysByLang = new Map<string, string[]>();
bundles.keys().forEach((key) => {
  const lang = key.slice(key.lastIndexOf('/') + 1, -'.wjs.jsx'.length);
  keysByLang.set(lang, [...(keysByLang.get(lang) ?? []), key]);
});

// One loader per lang: that lang's chunk for every scope.
export const LOADERS: Record<string, () => Promise<unknown>> =
  Object.fromEntries(
    [...keysByLang].map(([lang, keys]) => [
      lang,
      () => Promise.all(keys.map((key) => bundles(key))),
    ]),
  );
